$("[data-drawer-id=sidebar-resellers]").click( function () {
    $('#sidebar-resellers').attr('aria-hidden', false);
    $('#sidebar-resellers').attr('tabindex', -1);
  });
  
  $("[data-drawer-id=sidebar-resellers-close]").click( function () {
    $('#sidebar-resellers').attr('aria-hidden', true);
    $('#sidebar-resellers').removeAttr('tabindex');
  });
  
  $(".countryList").click( function () {
    $(this).closest(".Partnership__Inner").find('.countrySelected').first().show();
    $(this).closest(".Partnership__Inner").find('.countrySelected').first().text($(this)[0].innerText);
    $(this).closest(".Partnership__Inner").find('.countrySelected').first().parent().addClass('no-hover');
    $(this).closest(".Partnership__Inner").find('.countrySelected').first().parent().removeAttr("data-action");
    $(this).closest(".Partnership__Inner").find('.countrySelected').first().parent().removeAttr("aria-expanded");
    $(this).hide();
    $(".countryList").hide();
    $(".countryList").parent().hide();
    $(this).parent().parent().parent().css({"overflow":"visible", "height":"auto"});
    $(this).parent().show();
    //$(this).find('.Collapsible__Inner').first().css({"overflow":"visible", "height":"auto"});
    $(this).next().find(".cityList").first().show();
    $(this).next().find(".cityList").first().parent().parent().css({"overflow":"visible", "height":"auto"});
  });
  
  
  $(".cityLink").click( function () {
    $(this).closest(".Partnership__Inner").find('.citySelected').first().show();
    $(this).closest(".Partnership__Inner").find('.citySelected').first().text($(this)[0].innerText);
    $(this).closest(".Partnership__Inner").find('.citySelected').first().parent().addClass('no-hover');
    $(this).closest(".Partnership__Inner").find('.citySelected').first().parent().removeAttr("data-action");
    $(this).closest(".Partnership__Inner").find('.citySelected').first().parent().removeAttr("aria-expanded");
    $(this).hide();
    $(".cityList").hide();
    $(this).parent().show();
    $("#"+($(this)[0].innerText.replace(' ', '-'))).css({"overflow":"visible", "height":"auto"});
  });

  /*$(".citySelected").click( function () {
    if ($(this).innerText != '') {
      $(".countryList").show();
      $(this).text('');
      $(".citySelected").hide();
      $(".countryList[aria-expanded='true']").next().removeAttr("style");
      $(".countryList[aria-expanded='true']").attr('aria-expanded', false);
    }
  });*/
  
  $(".continents").click( function () {
    if ($(this).children('.citySelected')[0].innerText != '') {
      $(".shopListCollapsible").css({"overflow":"hidden", "height":"0px"});
      $(this).children('.citySelected').text('');
      $(this).children('.citySelected').hide();
      $(this).parent().parent().find(".cityList").show();
      $(this).parent().parent().find(".cityList a").show();
      $(this).attr("data-action", "toggle-collapsible");
    } else if ($(this).children('.countrySelected')[0].innerText != '') {
      $(".cityList").parent().parent().css({"overflow":"hidden", "height":"0px"});
      $(".shopList").parent().parent().css({"overflow":"hidden", "height":"0px"});
      $(".countryList[aria-expanded='true']").next().removeAttr("style");
      $(".countryList[aria-expanded='true']").show();
      $(".countryList[aria-expanded='true']").attr('aria-expanded', false);
      $(this).children('.countrySelected').text('');
      $(this).children('.countrySelected').hide();
      $(this).parent().parent().find(".countryList").show();
      $(this).attr("data-action", "toggle-collapsible");
      $(".countryList").show();
      $(".countryList").parent().show();
    } else {
      if ( $(this).parent().parent().find('.countryList').first().parent().parent().parent().css('overflow') == 'hidden' ) {
        $(".countryList").parent().parent().parent().css({"overflow":"hidden", "height":"0px"});
        $(".no-resellers").parent().parent().css({"overflow":"hidden", "height":"0px"});
        $(".countryList").parent().parent().parent().removeClass('no-hover');
        $(".continents").children('.citySelected').text('');
        $(".continents").children('.citySelected').hide('');
        $(".continents").children('.countrySelected').text('');
        $(".continents").children('.countrySelected').hide('');
        $(".countryList").show();
        $(".countryList").parent().show();
        $(".cityList").parent().parent().css({"overflow":"hidden", "height":"0px"});
        $(".shopList").parent().parent().css({"overflow":"hidden", "height":"0px"});
        $(".countryList").attr('aria-expanded', false);
        $(".countryList").attr("data-action", "toggle-collapsible");
        $(".continents").attr('aria-expanded', false);
        $(".continents").attr("data-action", "toggle-collapsible");
        $(this).parent().parent().find('.countryList').first().parent().parent().parent().css({"overflow":"visible", "height":"auto"});
      } else if ( $(this).parent().parent().find('.specific_onelevel').first().parent().css('overflow') == 'hidden' ) {
        $(".countryList").parent().parent().parent().css({"overflow":"hidden", "height":"0px"});
        $(".no-resellers").parent().parent().css({"overflow":"hidden", "height":"0px"});
        $(".countryList").parent().parent().parent().removeClass('no-hover');
        $(".continents").children('.citySelected').text('');
        $(".continents").children('.citySelected').hide('');
        $(".continents").children('.countrySelected').text('');
        $(".continents").children('.countrySelected').hide('');
        $(".countryList").show();
        $(".countryList").parent().show();
        $(".cityList").parent().parent().css({"overflow":"hidden", "height":"0px"});
        $(".shopList").parent().parent().css({"overflow":"hidden", "height":"0px"});
        $(".countryList").attr('aria-expanded', false);
        $(".countryList").attr("data-action", "toggle-collapsible");
        $(".continents").attr('aria-expanded', false);
        $(".continents").attr("data-action", "toggle-collapsible");
         $(this).parent().parent().find('.specific_onelevel').first().parent().css({"overflow":"visible", "height":"auto"});
      } else {
      	$(this).parent().parent().find(".countryList").first().parent().parent().parent().css({"overflow":"hidden", "height":"0px"});
        $(this).parent().parent().find(".no-resellers").first().parent().parent().css({"overflow":"hidden", "height":"0px"});
        $(this).parent().parent().find(".countryList").first().parent().parent().parent().removeClass('no-hover');
        $(this).parent().parent().find(".continents").first().children('.citySelected').text('');
        $(this).parent().parent().find(".continents").first().children('.citySelected').hide('');
        $(this).parent().parent().find(".continents").first().children('.countrySelected').text('');
        $(this).parent().parent().find(".continents").first().children('.countrySelected').hide('');
        $(this).parent().parent().find(".countryList").first().show();
        $(this).parent().parent().find(".countryList").first().parent().show();
        $(this).parent().parent().find(".cityList").first().parent().parent().css({"overflow":"hidden", "height":"0px"});
        $(this).parent().parent().find(".shopList").first().parent().parent().css({"overflow":"hidden", "height":"0px"});
        $(this).parent().parent().find(".countryList").first().attr('aria-expanded', false);
        $(this).parent().parent().find(".countryList").first().attr("data-action", "toggle-collapsible");
        $(this).parent().parent().find(".continents").first().attr('aria-expanded', false);
        $(this).parent().parent().find(".continents").first().attr("data-action", "toggle-collapsible");
        $(this).parent().parent().find(".countryList").first().show();
      }
    }
  });
/*
$('body').on('click', '.section_faq', function () {
  $('.Faq__SectionWrapper').hide();
  $('.open').show();
  $('.close').hide();
  //On active
  $(this).children('.open').hide();
  $(this).children('.close').show();
  $(this).next().slideToggle(300);
});

$('body').on('click', '.Faq__Question', function () {
  $('.Faq__AnswerWrapper').hide();
  $('.Faq__Question').removeClass('ActiveFaq');
  $(this).addClass('ActiveFaq');
  //Si c'est visible
  $('.open_sub').show();
  $('.close_sub').hide();
  $(this).next().hide();
  $(this).next().next().show();
  $(this).next().next().next().slideToggle(300);
});
*/

$('body').on('click', '.section_faq', function () {
    // Toggle the icon of the section
    $(this).children('.open').toggle();
    $(this).children('.close').toggle();
    if($(this).next().hasClass('active-faq-marker-section')) {
        // If the section is already opened, close it
        $('.active-faq-marker-section').removeClass("active-faq-marker-section");
    } else {
        // If an other section is opened, close it
        if($('.active-faq-marker-section').length) {
            $('.active-faq-marker-section').hide();
            $('.active-faq-marker-section').prev().children('.open').toggle();
            $('.active-faq-marker-section').prev().children('.close').toggle();
            // if a question is opened in the other section, close it
            if($('.ActiveFaq').length) {
                $('.ActiveFaq').next().next().next().hide();
                $('.ActiveFaq').removeClass("ActiveFaq");
            }
        }
        $('.active-faq-marker-section').removeClass("active-faq-marker-section");
        $(this).next().addClass("active-faq-marker-section");
    }
    $(this).next().slideToggle(300);
});

$('body').on('click', '.Faq__Question', function () {
    $(this).next().toggle();
    $(this).next().next().toggle();
    $(this).children('.close').toggle();
    if($(this).hasClass('ActiveFaq')) {
        // if the question is already opened, close it
        $('.ActiveFaq').removeClass("ActiveFaq");
    } else {
        // if an other question is opened, close it
        $('.ActiveFaq').hide();
        $(this).addClass("ActiveFaq");
    }
    $(this).next().next().next().slideToggle(300);
});

$('body').on('click', '.close_sub', function () {
  $('.Faq__AnswerWrapper').hide();
  $('.Faq__Question').removeClass('ActiveFaq');
  $('.open_sub').show();
  $('.close_sub').hide();
  $(this).prev().show();
  $(this).next().next().slideToggle(300);
});

$('body').on('click', '.open_sub', function () {
  $('.Faq__AnswerWrapper').hide();
  $('.Faq__Question').removeClass('ActiveFaq');
  $('.open_sub').show();
  $('.close_sub').hide();
  $(this).hide();
  $(this).next().show();
  $(this).prev().addClass('ActiveFaq');
  $(this).next().next().slideToggle(300);
});

$('body').on('click', '#closeQuickCart', function () {
     $(".quick-cart").removeClass('active');
  $(".quick-cart").removeClass('visible');
  $('body').css({"overflow":"visible"});
});

$("#cart_drawer_quick").click( function () {
  $('body').css({"overflow":"hidden"});
});


$('.header__cart-count').click( function () {
  return fetch('/cart?view=drawer&timestamp=' + Date.now(), {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (content) {
          content.text().then(function (html) {
       		$('#cart-content').html(html);
          });
	});
});


$('body').on('click', '.collection-sidebar__heading', function() {
  $('.collection-sidebar__group').removeClass('active');
  $('.collection-sidebar__heading').removeClass('active');
  if (!$('.filter_'+$(this).attr('id')).parent().hasClass("active")) {
    $('.filter_'+$(this).attr('id')).parent().addClass('active');
  }
  $('.filter_'+$(this).attr('id')).addClass('active');
  $(this).addClass('active')
});

$('body').on('click', '#closeSizeGuide', function() {
  $("#sidebar-sizeguide").attr('aria-hidden', true);
});

$('body').on('click', '.size-chart-link', function() {
  $("#sidebar-sizeguide").attr('aria-hidden', false);
});

$('body').on('click', '.section_size-chart', function() {
  $(this).next().slideToggle(200);
  if ($(this).find('.icon ').first().css("transform") == "matrix(0, 1, -1, 0, 0, 0)") {
    $(this).find('.icon ').first().css("transform","rotate(0deg)");
  } else {
  	$(this).find('.icon ').first().css("transform","rotate(90deg)");
  }
});

window.addEventListener('click', function(e){
  if(document.getElementById('sideBarFilter') === null) {
    //ça n'existe pas donc on ne fait rien
  } else if (document.getElementById('sideBarFilter').contains(e.target)){
    // Clicked in box
  } else{
    if(document.getElementById('sideBarFilter') === null) {
     // On ne fait rien 
    } else if ($('.collection-sidebar').hasClass("active")) {
    	$('.collection-sidebar').removeClass('active');
  	}
  }
});

/* OBSERVER CART */
var $cart = $(".quick-cart");
var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.attributeName === "class") {
      if ($cart.hasClass('visible') == true) {
        return fetch('/cart?view=drawer&timestamp=' + Date.now(), {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (content) {
          content.text().then(function (html) {
       		$('#cart-content').html(html);
          });
		});
      } else {
        $('body').css({"overflow":"visible"});
      }
    }
  });
});
observer.observe($cart[0], {
  attributes: true
});

